import { useNavigate } from 'react-router-dom';
import '../styles/Exhibition.css';

function Exhibition({ item }) {
    const navigate = useNavigate();

    const handleClick = () => {
        if (item && item.url) {
            if (item.external) {
                window.open(item.url, '_blank', 'noopener,noreferrer');
            } else {
                navigate(item.url);
            }
        }
    };

    const hasLink = item && item.url;

    return (
        <span
            className={`exhibition-item${hasLink ? ' clickable' : ''}`}
            onClick={handleClick}
            style={{ cursor: hasLink ? 'pointer' : 'default' }}
            tabIndex={hasLink ? 0 : -1}
            role={hasLink ? 'button' : undefined}
        >
            <span className="hover-text-only">
                {typeof item === 'string' ? item : item.label || item.name || item.title}
            </span>
        </span>
    );
}

export default Exhibition;
